import { render } from "./LanguageSwitcherCompact.vue?vue&type=template&id=6e8e39c4&ts=true"
import script from "./LanguageSwitcherCompact.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcherCompact.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__